import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Dashboard() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  // console.log("uid", userId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dash, setDash] = useState([]);

  const Dashboard_API = async () => {
    try {
      let responceRight = await API?.get(
        `/admindashboarddata?loginid=${userId}`,
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      responceRight = responceRight.data.data[0][0];
      console.log("Dashboard--->", responceRight);
      setDash(responceRight);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    Dashboard_API();
  }, []);

  return (
    <div>
      <Navbar />
      {/* {AdminRole.adminrole == "Admin" ? ( */}
      <>
        <div id="wrapper">
          <div class="content-page page_scroll_y">
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's CTO</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="DirectIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Non-Working Direct Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.DirectIncomeNon}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="DirectIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Non-Working Direct Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.DirectIncomeNon_TD}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoiIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Non-Working Roi Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.RoiIncomeNon}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoiIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Non-Working Roi Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.RoiIncomeNon_TD}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Non-Working Level Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.LevelIncomeNon}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Non-Working Level Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.LevelIncomeNon_TD}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoyaltyIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Non-Working Royalty Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.RoyaltyIncomeNon}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoyaltyIncome_nonworking">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Non-Working Royalty Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.RoyaltyIncomeNon_TD}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="DirectIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Stacking Direct Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.DirectIncomeStake}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="DirectIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Stacking Direct Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.DirectIncomeStake_TD}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoiIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Stacking Roi Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.RoiIncomeStake}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoiIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Stacking Roi Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.RoiIncomeStake_TD}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Stacking Level Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.LevelIncomeStake}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="LevelIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Stacking Level Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.LevelIncomeStake_TD}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoyaltyIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Stacking Royalty Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.RoyaltyIncomeStake}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="RoyaltyIncome">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Non-Working Royalty Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.RoyaltyIncomeStake_TD}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Paid Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPaidWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Paid Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPaidWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Net Balance</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalnetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Net Balance</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todaynetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activation Fund</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.FundTransfer}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Used Activation Fund</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.FundDeduct}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Balance Activation Fund</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.FundBalance}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      {/* ) : (
        <>
          <div id="wrapper">
            <div class="content-page page_scroll_y">
              <div class="content">
                <div class="container">
                  <div class="row">
                    <h3>Welcome SubAdmin </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
    </div>
  );
}

export default Dashboard;
